import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = { class: "col-12 col-md-4" }
const _hoisted_3 = { class: "col-12 col-md-4" }
const _hoisted_4 = { class: "col-12 col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_client_loader = _resolveComponent("client-loader")!
  const _component_social_accounts_card = _resolveComponent("social-accounts-card")!
  const _component_posts_card = _resolveComponent("posts-card")!
  const _component_albums_card = _resolveComponent("albums-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "bg-white q-pa-lg" }, {
    default: _withCtx(() => [
      _createVNode(_component_client_loader, {
        "client-id": _ctx.clientId,
        modelValue: _ctx.client,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event))
      }, null, 8, ["client-id", "modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_social_accounts_card, { "client-id": _ctx.clientId }, null, 8, ["client-id"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_posts_card, { "client-id": _ctx.clientId }, null, 8, ["client-id"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_albums_card, { "client-id": _ctx.clientId }, null, 8, ["client-id"])
        ])
      ])
    ]),
    _: 1
  }))
}